import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import FormatResourceStatusLabel from "go-app/components/FormatResourceStatus/FormatResourceStatus";
import { getComponentStatusClassName } from "go-component/Common/FormatStatus";

type labelType = "primary" | "success" | "danger" | "warning" | "secondary" | "blue";
const getStatusTranslationKey = (status: string) => {
	return `enums.common.status.${status}`;
};

export const getStatusClassName = (status: string, customStatuses?: { status: string; label: labelType }[]) => {
	const customStatus = customStatuses?.find((customStatus) => status === customStatus.status);
	if (customStatus) {
		return customStatus.label;
	}

	let labelClass = getComponentStatusClassName(status);
	if (labelClass) return labelClass;

	switch (status) {
		case "SHIPPED":
		case "PAID":
		case "UNLOCKED":
		case "OPENED":
		case "RECEIVED":
			labelClass = "success";
			break;
		case "DRAFT":
		case "INACTIVE_APP":
			labelClass = "warning";
			break;
		case "UNLINKED":
		case "PARTIALLY_RECEIVED":
		case "VOID":
		case "REVOKED":
		case "LOCKED":
		case "CLOSED":
			labelClass = "danger";
			break;
		case "PARTIALLY_SHIPPED":
		default:
			labelClass = "primary";
			break;
	}
	return labelClass;
};

interface Props {
	status: string;
	customStatuses?: { status: string; label: labelType }[];
}

const AppFormatResourceStatusLabel: FC<Props> = (props: Props) => {
	const status = props.status;
	const { t } = useTranslation();
	const labelClass = getStatusClassName(status, props.customStatuses);

	const translation = t(getStatusTranslationKey(status), { ns: ["translation", "lib"] });
	return <FormatResourceStatusLabel status={status} className={labelClass} translation={translation} />;
};

export default AppFormatResourceStatusLabel;
